import styled from 'styled-components';

export const SidebarContainer = styled.aside<{ bgColor: string }>`
  background-color: ${(props) => props.bgColor};
  height: 100%;
  grid-area: sidebar;
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding-top: 32px;
  border-right: 1px solid ${(props) => props.theme.colors.border.lighter};

  ${({ theme }) => theme.mediaQueries.md} {
    display: none;
  }
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const MenuItem = styled.div<{ activeColor: string; activeBgColor: string }>`
  width: 100%;
  cursor: pointer;

  * {
    cursor: pointer !important;
  }

  a {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding: 16px;
    transition: all 0.5s ease-in;
    position: relative;

    &::after {
      position: absolute;
      content: '';
      width: 0;
      right: 0;
      top: 0;
      bottom: 0;
      transition: all 0.5s ease-in;
    }

    &:focus,
    &.active {
      background-color: ${(props) => props.activeBgColor};

      > span {
        color: ${(props) => props.activeColor};
      }

      &::after {
        background-color: ${(props) => props.activeColor};
        width: 3px;
      }

      > svg {
        path[stroke] {
          stroke: ${(props) => props.activeColor};
        }

        path[fill] {
          fill: ${(props) => props.activeColor};
        }
      }
    }
  }
`;

export const BottomMenuContentWrapper = styled.div`
  position: sticky;
  bottom: 0;
  padding: 16px;
  width: 100%;
`;

export const BottomMenuContent = styled.div<{ bgColor: string }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 16px;
  border-radius: 10px;
  background-color: ${(props) => props.bgColor};
`;

export const AboveLinksContentWrapper = styled.div<{ borderColor: string }>`
  width: 100%;
  display: flex;
  padding: 0 16px 16px 16px;
  background-color: transparent;
  border-bottom: 1px solid ${(props) => props.borderColor};
`;

export const BelowLinksContentWrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 16px;
  background-color: transparent;
`;

export const SidebarStoryContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: ${(props) =>
    props.theme.rtl
      ? `1fr [sidebar-start] 184px [sidebar-end]`
      : `[sidebar-start] 184px [sidebar-end] 1fr`};
  grid-template-areas: ${(props) => (props.theme.rtl ? "'main sidebar'" : "'sidebar main'")};

  ${({ theme }) => theme.mediaQueries.md} {
    display: flex;
    flex-direction: column;
  }
`;
